export default {
  welcomealert: '第一次拜訪新 HKLII ？',
  tourlink: '查看首次使用說明',
  title: '新 HKLII 網站導覽',
  step1: '新版面',
  step2: '搜尋任何文件',
  step3: '進階搜尋',
  step4: '使用 Noteup',
  step5: '快速瀏覽法例',
  title1: '以功能劃分的版面配置',
  title2: '如何有效地在 HKLII 上搜尋',
  title3: '利用「進階搜尋」查詢欄位',
  title4: '使用 Noteup 功能尋找引用案例',
  title5: '使用法例導覽迅速閱讀條文',
  title6: '介紹完畢',
  desc1: [
    '<b>左側邊欄</b>展示相關的工具和資料，而與當前頁面有關的<b>連結將位於右</b>。',
    '於手機瀏覽時，網站的結構將調整至上至下排列。',
    '你可以使用視窗右下角的方向按鈕直達頁面頂端或底部。'
  ],
  desc2: [
    '在搜尋欄輸入關鍵字搜尋{0} HKLII 內的資料。你能在此使用{1}來有效掌握你的搜尋範圍。',
    '網站頂部的搜尋欄與首頁的搜尋欄有同樣的功能，讓你能在任何頁面作資料庫搜尋。'
  ],
  desc3: [
    '「進階搜尋」能夠在<b>指定範疇使用關鍵字</b>搜尋，從而收窄結果數量。',
    '運算子暫時未能在本頁使用。'
  ],
  desc4: [
    '在當前文件使用 <b>Noteup</b> 功能以便<b>快捷查看引用</b>或提及此文件的其他文件。'
  ],
  desc5: [
    '按<b>「一頁顯示所有內容」</b>以完整顯示法例內容。按<b>「目錄」</b>前往該法例的索引。',
    '使用<b>「往前/往後箭頭」</b>往返前後法例條文。',
    '你可以使用<b>「相關條例（附屬法例）」</b>快速前往相關法例。'
  ],
  desc6: [
    '本介紹告一段落。若有其他疑問或意見請{email}遞交。',
    'HKLII 感謝你的到訪，希望閣下能抽空為我們{rating}，讓 HKLII 更為你所用。'
  ],
  rating: '評分',
  email: '到此電郵',
  any_content: '任何',
  operators: '運算子',
  videoerror: '請使用 HTML 5 的瀏覽器觀看此說明。',
}